export const parseDateForPBI = rawDate => {
  const date = rawDate.split(' ');
  if (date.length !== 2) {
    return null;
  }
  let onlyDate = date[0];
  let onlyTime = date[1];

  onlyDate = onlyDate.split('/');
  onlyTime = onlyTime.split(':');

  if (onlyDate.length !== 3 || onlyTime.length !== 3) {
    return null;
  }
  return new Date(
    onlyDate[2],
    onlyDate[1] - 1,
    onlyDate[0],
    onlyTime[0],
    onlyTime[1],
    onlyTime[2],
  );
};
